import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LinkWithSpinnerUI from '../../../widgets/action/LinkWithSpinnerUI'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF'
import ChatMessageStatusModalSF from './ChatMessageStatusModalSF'
import ChatMessageSetFollowUpModalSF from './ChatMessageSetFollowUpModalSF'
import SuperUserAccountNameUI from '../../../templates/SuperUserAccountNameUI'
import SpinnerComponentUI from '../../common/SpinnerComponentUI'
import GenericErrorUI from '../../common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SwitchUI from '../../../widgets/action/SwitchUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import CaretUI from '../../../widgets/action/CaretUI'
import './ChatMessageList2.css'

const ChatMessageList2UI = ({ context, account, user, errorList, userMessageList, draftMessageList, filteredList, onRefreshClick,
  searchFilter, onSearchFilterChange, checked, onShowStarred, checked2, onShowUnread,
  chatContainerRef,
  onReplyClick, onReplyCancel, replyMode, selectedUserId, selectedAccountId, selectedPhone,
  onDownloadClick, downloadMode, selectedMesgDate,
  fileUploadMode, onFileUploadClick, onfileUploadCancel, onfileUpload,
  statusUpdateMode, onUpdateStatusClick, onUpdateStatusCancel,
  setFollowUpMode, onSetFollowUpClick, onSetFollowUpCancel, submitted,
  onMessageChange, message, onSendMessage, latestReceivedMessage
}) =>
  <SuperUserAccountNameUI context={context} className='pg_su_chat' accountUserList={filteredList}
    centered={!userMessageList} page={user && user.userId} dimension='w1000'
    topnav='chats' searchFilter={searchFilter} onSearchFilterChange={onSearchFilterChange}
    checked={checked2} onShowUnread={onShowUnread}
  >
    {
      !userMessageList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      account && userMessageList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <div className='g_flex_h'>
              <CaretUI direction='left' location='title' to={`/su/accounts/${account.accountId}/chats`} />
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              {/*
            context.permissions.includes('su_manage') &&
            <IconButtonUI messageList={messageList} icon='icon-pencil' onClick={onWriteClick} label='Write Message' />
          */}
              <span className='g_m_left_100 g_large'><b>{account.accountName}</b></span>
            </div>
          }
          right={
            <span className='g_flex_h g_flex_right'>
              <span className='g_muted g_m_right_50'>
                Starred
              </span>
              <SwitchUI
                checked={checked}
                onChange={onShowStarred}
              />
            </span>
          }
        />
        <div className='c_chat'>
          {
            userMessageList && userMessageList.length !== 0 && userMessageList.map((chats, i) =>
              <CardUI key={i} className='card'
                title={
                  <div className='g_flex_h'>
                    <span className='user_name'>
                      <span>{chats.addressableName}</span>
                      <span className='g_m_left_50'>{chats.phoneNumber}</span>
                    </span>
                    <Link to={`/su/accounts/${chats.accountId}/chat`} className='acc_name'>{chats.accountName}</Link>
                  </div>
                }
              >
                <div className="chat_list_scroll" ref={chatContainerRef}>
                  {
                    !checked && chats.chatMessageList.map((message, j) =>
                      <span className={`g_flex_h ${message.csr ? 'g_flex_right' : 'g_flex_left'}`} key={j}>
                        <ChatListUI context={context} message={message} onReplyClick={onReplyClick} onFileUploadClick={onFileUploadClick}
                          onDownloadClick={onDownloadClick} downloadMode={downloadMode} selectedMesgDate={selectedMesgDate}
                          onUpdateStatusClick={onUpdateStatusClick} onSetFollowUpClick={onSetFollowUpClick} />
                      </span>
                    )
                  }
                  {
                    checked && chats.chatMessageList.filter(f => f.followUp).map((message, j) =>
                      <span className={`g_flex_h ${message.csr ? 'g_flex_right' : 'g_flex_left'}`} key={j}>
                        <ChatListUI context={context} message={message} onReplyClick={onReplyClick} onFileUploadClick={onFileUploadClick}
                          onDownloadClick={onDownloadClick} downloadMode={downloadMode} selectedMesgDate={selectedMesgDate}
                          onUpdateStatusClick={onUpdateStatusClick} onSetFollowUpClick={onSetFollowUpClick} />
                      </span>
                    )
                  }
                </div>
              </CardUI>
            )
          }
          {
            userMessageList && userMessageList.length === 0 && draftMessageList && draftMessageList.map((chats, i) =>
              <CardUI key={i} className='card'
                title={
                  <div className='g_flex_h'>
                    <span className='user_name'>
                      <span>{chats.addressableName}</span>
                      <span className='g_m_left_50'>{chats.phoneNumber}</span>
                    </span>
                    <Link to={`/su/accounts/${chats.accountId}/chat`} className='acc_name'>{chats.accountName}</Link>
                  </div>
                }
              >
              </CardUI>
            )
          }
          <div className='chat_input_section'>
            <IconButtonUI icon='icon-paperclip' onClick={onFileUploadClick} />
            <textarea type='text' placeholder='Type a message...' className='chat_input'
              value={message} onChange={onMessageChange} disabled={submitted} />
            {/*<button className='reply_btn ai_reply'>
                <i className='icon-bot' /> Reply with AI
            </button>*/}
            <button className='reply_btn send_btn' onClick={onSendMessage} disabled={submitted}>
              <i className="icon-send" /> {submitted ? "Sending..." : "Reply"}
            </button>
          </div>

        </div>
      </div>
    }
    {
      userMessageList && userMessageList.length === 0 && draftMessageList && draftMessageList.length === 0 &&
      <EmptyListUI
        context={context} className='g_m_top_200'
        createDisabledMessageLabel='No messages'
      />
    }
    {/* <ChatMessageReplyModalSF context={context} account={account}
            replyMode={replyMode} selectedUserId={selectedUserId} selectedAccountId={selectedAccountId}
            selectedPhone={selectedPhone}
            onCancelClick={onReplyCancel} onRefreshClick={onRefreshClick}
        /> */}
    <ChatMessageStatusModalSF context={context} updateMode={statusUpdateMode}
      selectedAccountId={selectedAccountId} selectedMesgDate={selectedMesgDate}
      selectedPhone={selectedPhone}
      onCancelClick={onUpdateStatusCancel} onRefreshClick={onRefreshClick}
    />
    <ChatMessageSetFollowUpModalSF context={context} updateMode={setFollowUpMode}
      selectedAccountId={selectedAccountId} selectedMesgDate={selectedMesgDate}
      selectedPhone={selectedPhone}
      onCancelClick={onSetFollowUpCancel} onRefreshClick={onRefreshClick}
    />
    <FileUploadModalSF
      context={context}
      uploadMode={fileUploadMode}
      onCancelClick={onfileUploadCancel}
      signedUrlApi={`/api/su/accounts/${account && account.accountId}/files/fileUploadSignedUrl`}
      onUpload={onfileUpload}
      multiple={true}
    />
  </SuperUserAccountNameUI>

const ChatListUI = ({ context, message, onReplyClick, onDownloadClick, downloadMode, selectedMesgDate,
  onFileUploadClick, onUpdateStatusClick, onSetFollowUpClick }) =>
  <div className='chat_sec csr g_m_bottom_50'>
    <div className='g_flex_v g_m_left_50 g_m_right_50 g_m_top_25 g_m_bottom_25'>
      <span>{message.message}
        {
          message.fileList && message.fileList.map((file, i) =>
            <span className='g_flex_h g_flex_left' key={i}>
              <LinkWithSpinnerUI
                onClick={onDownloadClick} dataAccId={message.accountId ? message.accountId : message.phoneNumber}
                rowId={message.messageDate + ':' + file.fileId + ':' + file.fileName}
                busy={downloadMode && selectedMesgDate == message.messageDate} label={file.fileName}
              />
              <span className='g_m_left_50 g_muted'>{file.sizeF}</span>
            </span>
          )
        }
      </span>
      <div className='g_flex_h g_m_top_25'>
        <span className='g_small g_muted'>{message.messageDateTimeF}</span>
        <span className='g_flex_h g_flex_right'>
          <span className='g_m_left_50 icon icon-archive g_muted' onClick={onUpdateStatusClick}
            data-acc-id={message.accountId} data-date={message.messageDate} data-phone={message.phoneNumber} />
          <span className={`g_m_left_50 ${message.followUp ? 'icon icon-star' : 'icon icon-star-o'}`} onClick={onSetFollowUpClick}
            data-acc-id={message.accountId} data-date={message.messageDate} data-phone={message.phoneNumber} />
        </span>
      </div>
    </div>
  </div>

export default ChatMessageList2UI
